import { HausbankFieldTypes } from 'hausbank/inquiry/fields';

type HausbankWegSearchFieldTypes = HausbankFieldTypes['companyDataPage']['wegSearchSection'];

export const mapHausbankWegSearch = (values: HausbankWegSearchFieldTypes) => ({
  crefo_id: values.crefoId,
});
